import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "@/mocks/site";

export function useSyncLanguage(lang?: string): string {
  const { i18n } = useTranslation();
  useEffect(() => {
    const target = lang && SUPPORTED_LANGS.includes(lang as never) ? lang : "en";
    if (i18n.language !== target) {
      i18n.changeLanguage(target);
    }
  }, [lang, i18n]);
  return lang && SUPPORTED_LANGS.includes(lang as never) ? lang : "en";
}